import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import Icons from '../../../Elements/Icons/index.js';
import { DragHandle } from './DragHandle.js';
export const DragCell = memo(function DragCell({ dragHandleRef }) {
    if (dragHandleRef) {
        return (_jsx(DragHandle, { ref: dragHandleRef, children: _jsx(Icons.Drag, { size: 20 }) }));
    }
    return _jsx(Icons.Drag, { size: 20, "aria-hidden": 'true' });
});
